import useDirtyForm from './useDirtyForm';
import Selector from '../../components/forms/Selector';
import ClassificationSelect from './ClassificationSelect';
import IconSave from '../../components/icons/IconSave';
import language from '../../variables/language';

const resolveValue = (val) => {
   if(val && typeof val === 'object' && val.id !== undefined) return String(val.id);
   if(val === null || val === undefined) return '';
   return String(val);
};

function flattenCourse(course) {
   return {
      name: resolveValue(course.name),
      description: resolveValue(course.description),
      level: resolveValue(course.level),
      classification: resolveValue(course.classification),
   };
}

// Full Course-entity editor (name/description/level/classification) -
// distinct from the generic HierarchyNodeForm (name+description only,
// shared by Course + the 5 hierarchy levels below it) since level/
// classification only exist on Course. Only reachable via the "Редагувати
// курс" header button in Workspace.jsx, not via the outline tree.
export default function CourseEditForm({ course, onSave, onClose }) {
   const lang = language[language.lang];
   const { formValues, isDirty, saving, handleFieldChange, handleDiscard, handleSave } = useDirtyForm(course, flattenCourse, onSave);

   if(!formValues) return '';

   return (
      <div className='course-node-form course-edit-form'>
         <div className='course-edit-form-header'>
            <span className='course-node-form-level-label'>Редагування курсу</span>
            <div className='course-edit-form-close-btn' onClick={onClose} title='Закрити'>×</div>
         </div>
         <input className='course-node-form-name' value={formValues.name}
            placeholder={lang.name} onChange={e => handleFieldChange('name', e.target.value)} />
         <textarea className='course-node-form-description' rows={4}
            placeholder={lang.description} value={formValues.description}
            onChange={e => handleFieldChange('description', e.target.value)} />
         <div className='course-edit-form-meta-row'>
            <div className='flex-from-input-wraper course-edit-form-meta-field' data-label={lang.level}>
               <Selector className='submit-field form-selection txt-c'
                  name='level' url='/api/levels' value={formValues.level}
                  selectorsHundler={(value) => handleFieldChange('level', value)} />
            </div>
            <div className='flex-from-input-wraper course-edit-form-meta-field' data-label={lang.clasification}>
               <ClassificationSelect className='submit-field form-selection txt-c'
                  value={formValues.classification} onChange={(value) => handleFieldChange('classification', value)} />
            </div>
         </div>
         {isDirty ? (
            <div className='course-node-form-footer'>
               <span className='course-node-form-unsaved-hint'>{lang.unsavedChanges}</span>
               <div className='course-node-form-discard' onClick={handleDiscard}>{lang.cancel}</div>
               <button type='button' className='course-node-form-save-btn' disabled={saving} onClick={handleSave}>
                  <IconSave />
                  {saving ? lang['Loading ...'] : lang.save}
               </button>
            </div>
         ) : ''}
      </div>
   );
}
